module.exports = __webpack_public_path__ + "img/stats_empty.a3c1c9af.png";